export default {
    state: {
        roomsStyles: [],
        roomDetails: [],
        booking: [],
        statusOfPost: '',
    },

}


// export default {

//     roomsStyles: [],
//     roomDetails: [],
//     booking: [],
//     statusOfPost: '',

// }